import Swal from "sweetalert2";

// Identificador de este build (lo pone scripts/build.js). En desarrollo
// ("npm start") no existe y la verificacion se omite.
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || "";

const TIEMPO_MAXIMO_MS = 4000;

// Compara el id que trae la app contra el de /version.json del servidor. Regresa:
//   { estado: "sin_identificador" }               la app no trae id (desarrollo)
//   { estado: "vigente",  idPublicado }           coinciden
//   { estado: "nueva",    idPublicado }           el servidor tiene OTRA version publicada
//   { estado: "desconocida" }                     sin internet, archivo ausente o respuesta rara
export async function consultarVersionPublicada(buildId = BUILD_ID) {
  if (!buildId) return { estado: "sin_identificador" };

  const controlador = new AbortController();
  const temporizador = setTimeout(() => controlador.abort(), TIEMPO_MAXIMO_MS);
  try {
    const respuesta = await fetch(`/version.json?_=${Date.now()}`, {
      cache: "no-store",
      signal: controlador.signal,
    });
    if (!respuesta.ok) return { estado: "desconocida" };
    const datos = await respuesta.json();
    if (!datos || !datos.id) return { estado: "desconocida" };
    const idPublicado = String(datos.id);
    return { estado: idPublicado === String(buildId) ? "vigente" : "nueva", idPublicado };
  } catch (error) {
    return { estado: "desconocida" };
  } finally {
    clearTimeout(temporizador);
  }
}

// Devuelve false SOLO si el servidor confirma que hay otra version publicada.
// Ante cualquier duda (sin id, sin internet, archivo ausente, respuesta rara)
// devuelve true: un fallo de esta revision nunca debe impedir un cobro.
export async function versionEsVigente(buildId = BUILD_ID) {
  const { estado } = await consultarVersionPublicada(buildId);
  return estado !== "nueva";
}

// Se llama justo ANTES de pasar la tarjeta. Si hay una version nueva avisa y
// devuelve false (el cobro no debe continuar); si todo va bien devuelve true.
export async function asegurarVersionVigente() {
  if (await versionEsVigente()) return true;

  await Swal.fire({
    icon: "warning",
    title: "Hay una versión nueva de Multipagos",
    html:
      "El sistema se actualizó mientras tenías esta página abierta.<br><br>" +
      "<b>No se cobró nada a la tarjeta.</b> Actualiza la página con <b>Ctrl + F5</b> " +
      "y vuelve a intentar el cobro.",
    confirmButtonText: "Entendido",
  });
  return false;
}
